"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats: {
  value: number;
  suffix: string;
  label: string;
}[] = [];
function StatItem({
  stat,
  index
}: {
  stat: {
    value: number;
    suffix: string;
    label: string;
  };
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.5,
    once: true
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const duration = 2000;
    const frameRate = 16;
    const totalFrames = duration / frameRate;
    const increment = stat.value / totalFrames;
    const timer = setInterval(() => {
      start += increment;
      if (start >= stat.value) {
        setCount(stat.value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, frameRate);
    return () => clearInterval(timer);
  }, [stat.value, isVisible]);
  return <div data-section-id="125058" ref={ref} data-index={index} className="flex flex-col items-center justify-center text-center space-y-4 p-6">
      <div className="text-6xl md:text-7xl lg:text-8xl font-serif font-bold text-secondary tracking-tighter drop-shadow-md">
        {count}
        {stat.suffix}
      </div>
      <div className="text-sm md:text-base font-mono font-medium text-muted uppercase tracking-widest max-w-[200px] leading-tight">
        {stat.label}
      </div>
    </div>;
}
export default function OurImpactInNumbers() {
  return <section id="health-vitality-by-the-numbers" className="relative w-full bg-[#0a101f] py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-5 mix-blend-overlay">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612706/img/topographic_map_texture.png')] bg-cover bg-center bg-no-repeat" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 divide-y sm:divide-y-0 sm:divide-x divide-secondary/10">
          {}
        </div>
      </div>
    </section>;
}